import React, { FC } from "react";
import { B2Divider } from "@hdb/biome-2";

interface TitleComponentProps {
  title: string;
}

const TitleComponent: FC<TitleComponentProps> = ({ title }: any) => {
  return <B2Divider title={title} dashed className="fs-4 my-3" />;
};

export default TitleComponent;
